import { useAuth } from "@/contexts/AuthContext";

/**
 * Returns the appropriate "back home" path based on the current user's role.
 * Used so that an admin browsing teacher pages doesn't get sent to /teacher.
 */
export function useBackHomePath() {
    const { user } = useAuth();
    if (!user) return "/";
    switch (user.role) {
        case "super_admin": return "/admin";
        case "secretary": return "/secretary";
        case "quality_coordinator": return "/quality";
        case "parent": return "/parent";
        case "student": return "/student";
        case "teacher":
        default: return "/teacher";
    }
}
